export const separateFullName = (fullName) => {
  const nameArray = fullName.trim().split(' ')
  const firstName = nameArray[0]
  const lastName = nameArray.slice(1).join(' ')
  return { firstName, lastName }
}
